import { useMemo, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import type { TagCount } from '../api/tags'
import { getUserTags } from '../api/tags'
import { useAuthorTheme } from '../hooks/useAuthorTheme'
import { usePageHeader } from '../hooks/usePageHeader'
import { useUsername } from '../hooks/useUsername'
import { useAuthStore } from '../store/auth'

export function Tags() {
  const username = useUsername()
  const currentUser = useAuthStore((s) => s.username)
  const navigate = useNavigate()
  useAuthorTheme(username ?? undefined)
  const [tags, setTags] = useState<TagCount[]>([])
  const [loading, setLoading] = useState(true)
  const [newTagInput, setNewTagInput] = useState('')

  const isOwner = currentUser === username

  useEffect(() => {
    if (!username) return
    setLoading(true)
    getUserTags(username)
      .then(setTags)
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [username])

  function handleNewTag(e: React.FormEvent) {
    e.preventDefault()
    const tag = newTagInput.trim()
    if (!tag || !username) return
    navigate(`/~${username}/tags/${encodeURIComponent(tag)}?compose=1`)
  }

  const titleNode = useMemo(() => (
    username ? (
      <><Link to={`/~${username}`} style={{ color: 'inherit', textDecoration: 'none', opacity: 0.6 }}>~{username}</Link>{' / tags'}</>
    ) : 'tags'
  ), [username])

  usePageHeader(titleNode)

  return (
    <div>
      {isOwner && (
        <form onSubmit={handleNewTag} style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
          <input
            value={newTagInput}
            onChange={(e) => setNewTagInput(e.target.value)}
            placeholder="new tag"
            style={{ width: 'auto', flex: 1, maxWidth: 220 }}
          />
          <button type="submit" style={{ width: 'auto' }}>create</button>
        </form>
      )}

      {loading ? (
        <p>loading…</p>
      ) : tags.length === 0 ? (
        <p style={{ opacity: 0.5 }}>no tags yet</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '1rem' }}>
          {tags.map((t) => (
            <Link
              key={t.name}
              to={`/~${username}/tags/${encodeURIComponent(t.name)}`}
              style={{
                background: 'var(--color-fg)',
                color: 'var(--color-bg)',
                padding: '0.15rem 0.5rem',
                borderRadius: 2,
                fontSize: '0.85rem',
                textDecoration: 'none',
              }}
            >
              #{t.name}{' '}
              <span style={{ opacity: 0.6, fontSize: '0.78rem' }}>({t.count})</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
